import HomeStyles from "../styles/pages/HomeStyles";

const { StyledCardDiv, StyledCardTitle, StyledCardText } = HomeStyles;

interface IHomeCardProps {
    icon: any;
    imgDescription: string;
    title: string;
    text: string;
}

const HomeCard: React.FC<IHomeCardProps> = ({
    icon,
    imgDescription,
    title,
    text,
}) => {
    return (
        <StyledCardDiv>
            <div style={{ display: "flex" }}>
                {!!icon && <img src={icon} alt={imgDescription} />}
                <StyledCardTitle>{title}</StyledCardTitle>
            </div>
            <StyledCardText>{text}</StyledCardText>
        </StyledCardDiv>
    );
};

export default HomeCard;
